import type { EdgeId, EdgeInstance, NodeId, NodeInstance, Position } from '../domain/types';

export function getValidSelection(
  nodes: Record<NodeId, NodeInstance>,
  edges: Record<EdgeId, EdgeInstance>,
  selectedNodeIds: ReadonlySet<NodeId>,
  selectedEdgeIds: ReadonlySet<EdgeId>
): { nodeIds: NodeId[]; edgeIds: EdgeId[] } {
  return {
    nodeIds: Array.from(selectedNodeIds).filter((id) => Boolean(nodes[id])),
    edgeIds: Array.from(selectedEdgeIds).filter((id) => Boolean(edges[id])),
  };
}

export function getNodePortPosition(
  node: NodeInstance | undefined,
  transientPosition: Position | undefined,
  measuredOffset: Position | undefined,
  isOutput: boolean
): Position {
  const position = transientPosition || node?.position || { x: 0, y: 0 };
  if (node?.collapsed) {
    return {
      x: position.x + (isOutput ? node.size?.width ?? 208 : 0),
      y: position.y + 16,
    };
  }
  const offset = measuredOffset || { x: 0, y: 0 };
  return { x: position.x + offset.x, y: position.y + offset.y };
}

export function getMarqueeNodeIds(
  nodes: Record<NodeId, NodeInstance>,
  start: Position,
  current: Position,
  baseSelection: ReadonlySet<NodeId> = new Set()
): NodeId[] {
  const minX = Math.min(start.x, current.x);
  const maxX = Math.max(start.x, current.x);
  const minY = Math.min(start.y, current.y);
  const maxY = Math.max(start.y, current.y);
  const hits = new Set(baseSelection);

  for (const [id, node] of Object.entries(nodes)) {
    const width = node.size?.width ?? 220;
    const height = node.size?.height ?? 120;
    if (
      node.position.x < maxX &&
      node.position.x + width > minX &&
      node.position.y < maxY &&
      node.position.y + height > minY
    ) {
      hits.add(id);
    }
  }

  return Array.from(hits);
}
